module.exports = __webpack_public_path__ + "img/iap-success.d9f4c641.svg";